import { getPhotographer, getAllMediasForPhotographer } from "../../../app/lib/prisma-db.js";
import Header from "../../../app/components/Header/Header.jsx";
import styles from "page.module.css";

export default async function Page({params}){
    const { slug } = await params;
    const id = parseInt(slug.split("-")[0]);
    const photographer = await getPhotographer(id);
    const medias = await getAllMediasForPhotographer(id);

    return(
        <>
        <div>

        </div>
        </>
    )
}

